import { useEffect, useState } from "react";
import useAuth from "src/hooks/useAuth";
//components
import { LabelFromAction } from "src/components/@dashboard/automacoes";
import HorarioAtendimentoAutomacao from "../components/HorarioAtendimentoAutomacao";
// ui
import { Divider } from "@mui/material";
import { RowInput } from "src/components/forms/RowInput";
import { MultiSelect } from "src/@/components/ui/multi-select";
import { Switch } from "src/@/components/ui/switch";
import { Button } from "src/@/components/ui/button";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "src/@/components/ui/select";
import { Input } from "src/@/components/ui/input";
import { Card, CardHeader, CardContent } from "src/@/components/ui/card";
import { RadioGroup, RadioGroupItem } from "src/@/components/ui/radio-group";
import { Label } from "src/@/components/ui/label";
//actions
import v2_actionListSectorsByClient from "src/actions/v2/cliente/v2_actionListSectorsByClient";
import getActionListaUsuariosByClienteId from "src/actions/usuarios/getActionListaUsuariosByClienteId";
import v2_actionConfigCrm from "src/actions/v2/crm/v2_actionConfigCrm";
import { SwitchInput } from "src/components/ui-component/switch/Switch";
import AutomationOnlyExecute from "../components/AutomationOnlyExecute";
import v2_actionListaTagsChats from "src/actions/v2/chats/v2_actionListaTagsChats";
import actionListaCanaisPorCliente from "src/actions/clientes/actionListaCanaisPorCliente";

const TIME_UNITS = [
  { label: "Minuto(s)", value: 1 },
  { label: "Hora(s)", value: 60 },
  { label: "Dia(s)", value: 1440 },
  { label: "Semana(s)", value: 10080 },
  { label: "Mês(es)", value: 43200 },
];

const STATUS = [
  {
    value: "Atendendo",
    label: "Atendendo"
  },
  {
    value: "Avaliando",
    label: "Avaliando"
  },
  {
    value: "Pendente",
    label: "Em Fila"
  },
  {
    value: "Geral",
    label: "No bot"
  },
  {
    value: "Finalizado",
    label: "Finalizado"
  }
]


const CardInatividadeChat = ({ actionState, changeActionState, actionPhase, user, diasSemana }) => {
  const { cliente } = useAuth();
  const [configCrm, setConfigCrm] = useState(null);

  const [users, setUsers] = useState([]);
  const [departments, setDepartments] = useState([]);

  const [selectedPipe, setSelectedPipe] = useState(null);
  const [selectedPhase, setSelectedPhase] = useState(null); // Use null instead of an empty string

  const [tags, setTags] = useState([]);
  const [canais, setCanais] = useState([]);

  async function buscarListaTags() {
    try {
      const querys = `?cliente_id=${cliente._id}`;
      const response = await v2_actionListaTagsChats(querys);
      setTags(response.data.data);
    } catch (error) {
      console.error("Erro ao buscar lista de tags:", error);
    }
  }

  async function buscarListaCanais() {
    try {
      const response = await actionListaCanaisPorCliente(cliente._id);
      setCanais(response.data.data || []);
    } catch (error) {
      console.error("Erro ao buscar lista de canais:", error);
    }
  }

  useEffect(() => {
    buscarListaTags();
    buscarListaCanais();
  }, []);

  const listFormat = tags.map((tag) => ({
    value: tag._id,
    label: tag.nome,
  }));





  let usersFormatted = users?.map((user) => {
    return {
      value: user._id,
      label: user.nomeFantasia
    }
  });

  let departmentsFormatted = departments?.map((department) => {
    return {
      value: department._id,
      label: department.nome_setor
    }
  });

  let canaisFormatted = canais?.map((canal) => {
    return {
      value: canal.cliente_id || canal.clienteId,
      label: canal.nome
    }
  });

  async function getUsers() {
    try {
      const response = await getActionListaUsuariosByClienteId(user?.clienteId);
      setUsers(response.data.usuarios);

    } catch (error) {
      console.log(error);
    }
  }


  async function getListSectors() {
    try {
      const response = await v2_actionListSectorsByClient(user?.clienteId);
      setDepartments(response.data.data)
    } catch (error) {
      console.log(error);
    }
  }


  useEffect(() => {
    getUsers();
    getListSectors();
  }, []);


  async function buscarConfigCrm(querys) {
    try {
      const result = await v2_actionConfigCrm(cliente._id, querys);
      if (result.data.data) {
        setConfigCrm(result.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (actionState?.pipelineId) {
      buscarConfigCrm(`?pipeline_id=${actionState.pipelineId}`);
    } else {
      buscarConfigCrm();
    }
  }, [actionState]);



  return (
    <Card className="w-full">
      <CardHeader>
        <LabelFromAction>{actionPhase.name}</LabelFromAction>
      </CardHeader>
      <CardContent>
        <div className="space-y-4 flex gap-2 flex-col">
          <div>
            <RowInput
              isRequired={true}
              label="Canal"
              info={"Canais que estão atrelados ao chat"}
              input={
                <MultiSelect
                  options={canaisFormatted}
                  onValueChange={(e) =>
                    changeActionState({ name: "chatChannels", value: e })
                  }
                  defaultValue={actionState.chatChannels}
                  placeholder="Selecionar canais"
                  variant="inverted"
                  animation={2}
                  maxCount={3}
                />
              }
            />
          </div>

          <div>
            <RowInput
              isRequired={true}
              label="Status do Chat"
              input={<MultiSelect
                options={STATUS.map((status) => ({
                  value: status.value,
                  label: status.label,
                }))
                }
                onValueChange={(e) => changeActionState({ name: "chatStatus", value: e })}
                defaultValue={actionState?.chatStatus}
                placeholder="Selecionar status"
                variant="inverted"
                animation={2}
                maxCount={3}
              />}
            />

          </div>

          {actionState.chatStatus?.length > 0 && (
            <div>
              <RowInput
                isRequired={true}
                label="Tipo de Inatividade"
                input={
                  <RadioGroup
                    value={actionState?.inactivityType || "cliente"}
                    onValueChange={(value) => changeActionState({ name: "inactivityType", value })}
                    className="flex flex-row gap-4"
                  >
                    <div className="flex items-center space-x-2">
                      <RadioGroupItem value="cliente" id="cliente" />
                      <Label htmlFor="cliente" className="cursor-pointer">Cliente</Label>
                    </div>
                    <div className="flex items-center space-x-2">
                      <RadioGroupItem value="agente" id="agente" />
                      <Label htmlFor="agente" className="cursor-pointer">Agente/Plataforma</Label>
                    </div>
                  </RadioGroup>
                }
              />
            </div>
          )}

          {actionState.chatStatus?.length > 0 && (
            <div className="flex flex-col gap-2">
              <div>
                <RowInput
                  isRequired={true}
                  label="Tempo de Inatividade"
                  input={<div className="flex gap-2">
                    <Input
                      type="number"
                      // Se a unidade for minutos (valor 1), define o mínimo como 5; senão, como 1.
                      min={actionState?.timeUnitInativity == 1 ? 5 : 1}
                      value={actionState?.timeInativity}
                      onChange={e => {
                        let value = Number(e.target.value);
                        // Se a unidade for minutos, não permite valor abaixo de 5
                        if (actionState?.timeUnitInativity == 1 && value < 5) {
                          value = 5;
                        }
                        changeActionState({ name: "timeInativity", value });
                      }}
                      className="w-1/2"
                    />
                    <Select
                      value={actionState?.timeUnitInativity}
                      onValueChange={(selectedValue) => {
                        const unitValue = Number(selectedValue);
                        changeActionState({ name: "timeUnitInativity", value: unitValue });
                        // Se for selecionada a unidade de minutos e o valor atual for menor que 5,
                        // atualiza para 5 automaticamente.
                        if (unitValue === 1 && Number(actionState?.timeInativity) < 5) {
                          changeActionState({ name: "timeInativity", value: 5 });
                        }
                      }}
                    >
                      <SelectTrigger className="w-1/2">
                        <SelectValue placeholder="Selecione uma unidade" />
                      </SelectTrigger>
                      <SelectContent>
                        {TIME_UNITS.map((unit) => (
                          <SelectItem key={unit.value} value={unit.value}>
                            {unit.label}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>}
                />

              </div>

              <div className="text-sm font-semibold bg-slate-100 p-2 rounded-md mt-4">
                Filtros
              </div>


              <div className="flex flex-col gap-2">
                {actionState.chatStatus.includes("Pendente") && (
                  <RowInput
                    label="Setores do chat"
                    info={"Setores que estão atrelados ao chat"}
                    input={
                      <MultiSelect
                        options={departmentsFormatted}
                        onValueChange={(e) =>
                          changeActionState({ name: "chatDepartamentsAssign", value: e })
                        }
                        defaultValue={actionState.chatDepartamentsAssign}
                        placeholder="Selecionar setores"
                        variant="inverted"
                        animation={2}
                        maxCount={3}
                      />
                    }
                  />
                )}

                <RowInput
                  label="Usuários do chat"
                  info={"Usuários que estão atrelados ao chat"}
                  input={
                    <MultiSelect
                      options={usersFormatted}
                      onValueChange={(e) =>
                        changeActionState({ name: "chatUsersAssign", value: e })
                      }
                      defaultValue={actionState.chatUsersAssign}
                      placeholder="Selecionar usuarios"
                      variant="inverted"
                      animation={2}
                      maxCount={3}
                    />
                  }
                />
              </div>
            </div>
          )}


          <Divider className="border-dashed" />

          <div className="flex items-center gap-2 mt-8">
            <Switch
              checked={actionState.ignorePreviousActivities}
              onCheckedChange={(checked) => changeActionState({ name: "ignorePreviousActivities", value: checked })}
            />
            <label className="text-sm font-medium">Desconsiderar chats com atividades anteriores (recomendado)</label>
          </div>

          <AutomationOnlyExecute
            actionState={actionState}
            changeActionState={changeActionState}
          />

          <Divider sx={{ mt: 4, mb: 2, borderStyle: 'dashed' }} />

          <HorarioAtendimentoAutomacao
            diasSemana={diasSemana}
            customSchedule={actionState.scheduleCustom}
            changeCustomScheduleService={value => {
              changeActionState({ name: "scheduleCustom", value: value })
            }}
            scheduleService={actionState.schedule || []}
            changeScheduleService={(index, key, value) => {
              let newSchedule = [...actionState.schedule];
              newSchedule[index] = {
                ...newSchedule[index],
                [key]: value,
              };
              changeActionState({
                name: "schedule",
                value: newSchedule,
              });
            }}

          />

          <Divider sx={{ mt: 4, mb: 2, borderStyle: 'dashed' }} />


          <RowInput
            label="Tags chat"
            input={
              <MultiSelect
                options={listFormat}
                onValueChange={(e) =>
                  changeActionState({ name: "chatTags", value: e })
                }
                defaultValue={actionState.chatTags}
                placeholder="Selecionar Tags"
                variant="inverted"
                animation={2}
                maxCount={3}
              />
            }
          />


          <div>
            <label className="block text-sm font-medium">No funil</label>
            <div className="flex gap-2">
              <Select
                value={actionState.pipelineId}
                onValueChange={e => {
                  let event = {
                    name: "pipelineId",
                    value: e
                  }
                  changeActionState(event);
                  let querys = `?pipeline_id=${e}`;
                  buscarConfigCrm(querys);
                }}>
                <SelectTrigger className="w-full">
                  <SelectValue placeholder={selectedPipe} />
                </SelectTrigger>
                <SelectContent>
                  {configCrm?.pipelines.map((pipe) => (
                    <SelectItem key={pipe._id} value={pipe._id}>
                      {pipe.nome}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              <Button
                variant="ghost"
                size="icon"
                className="h-10 w-10"
                onClick={() => {
                  changeActionState({ name: "pipelineId", value: null });
                  buscarConfigCrm();
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-x"><path d="M18 6 6 18" /><path d="m6 6 12 12" /></svg>
              </Button>
            </div>
          </div>


          <div>
            <label className="block text-sm font-medium">Estágio</label>
            <div className="flex gap-2">
              <Select
                value={actionState.stageId}
                onValueChange={e => {
                  let event = {
                    name: "stageId",
                    value: e
                  }
                  changeActionState(event);
                }}>
                <SelectTrigger className="w-full">
                  <SelectValue placeholder={selectedPhase ? selectedPhase : "Selecione..."} />
                </SelectTrigger>
                <SelectContent>
                  {/* Add valid phase options */}
                  {configCrm?.stages.map((stage) => (
                    <SelectItem key={stage._id} value={stage._id}>
                      {stage.nome}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              <Button
                variant="ghost"
                size="icon"
                className="h-10 w-10"
                onClick={() => {
                  changeActionState({ name: "pipelineId", value: null });
                  changeActionState({ name: "stageId", value: null });
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-x"><path d="M18 6 6 18" /><path d="m6 6 12 12" /></svg>
              </Button>
            </div>
          </div>

        </div>
      </CardContent>
    </Card>
  );
};

export default CardInatividadeChat;
